import {
  ApplicationConfig, inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {tokenInterceptor} from './autorization/token.interceptor';
import {AuthService} from './autorization/auth/auth.service';
import {providePrimeNG} from 'primeng/config';
import Material from '@primeng/themes/material';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {ConfigService} from '../environments/services/config-environment.service';

export const appConfig: ApplicationConfig = {
  providers: [
    AuthService,
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideAppInitializer(async () => {
      const configService = inject(ConfigService);
      await configService.loadConfig();
    }),
    provideZonelessChangeDetection(),
    providePrimeNG({
      theme: {
        preset: Material
      },
      ripple: true
    }),
    provideHttpClient(withInterceptors([tokenInterceptor])),
  ]
};
